import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import {
  Box,
  ButtonStyled,
  FormEleWrapper,
  HeadingStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import ProfileUpload from "../../../components/common/uploadFiles/profileUpload";
import {
  LeftArrowBlack,
  RightArrowWithoutBar,
  UserPlaceholder,
} from "../../../components/styled/AllImages";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import { useUser } from "../../../context/userContext";
import { toast } from "react-toastify";
import ProfileApi from "../../../services/api/profileApi";

const AccountSetting = () => {
  const { t } = useTranslation();
  const { user, fetchUserInfo } = useUser();
  const [profileImg, setProfileImg] = useState(null);
  const [loading, setLoading] = useState(false);

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  useEffect(() => {
    if (user) {
      setValue("name", user.name || "");
      setValue("email", user.email || "");
      setValue("phone", user.phone || "");
      const profileUrl = user.profile
        ? `${process.env.REACT_APP_ASSET_URL}/${user.profile}`
        : UserPlaceholder;
      setProfileImg(profileUrl);
    }
  }, [user, setValue]);

  const onSubmit = async (formData) => {
    try {
      setLoading(true);

      const updatedData = new FormData();
      updatedData.append("action", "create");

      Object.entries(formData).forEach(([key, value]) => {
        updatedData.append(key, value);
      });

      if (profileImg && !updatedData.has("profile")) {
        updatedData.append("profile", profileImg);
      }

      const response = await ProfileApi.updateProfile(updatedData);
      if (response.code === 200) {
        toast.success(`${t("Info")} ${t("Updated_Successfully")}`);
        await fetchUserInfo();
        reset();
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="profileAvatarContainer">
          <Box className="profileAvatarImg">
            <ValidationController
              name={"profile"}
              validationConfig={{
                required: false,
              }}
              errors={errors}
              control={control}
              renderer={({ field }) => (
                <ProfileUpload
                  UploadImage="UploadLogo"
                  // onFileSelect={field.onChange} // Pass react-hook-form's onChange
                  onFileSelect={(file) => {
                    field.onChange(file); // Update form field
                    setProfileImg(file); // Update logo file state
                  }}
                  initialImage={profileImg} // Pass the preloaded image URL
                />
              )}
            />
            {/* <Box className="profileAvatarImgContainer">
                            <img className="profileAvatar" src={ProfileImgLarge} />
                            <Box className="profileCamera">
                                <Camera />
                            </Box>
                        </Box> */}
            <Box className="profileUserNameWrapper">
              <HeadingStyled color="var(--text)" size="24px">
                {user?.name}
              </HeadingStyled>
              <TextStyled lh="1">{user?.position || null}</TextStyled>
            </Box>
          </Box>
        </Box>
        <Box className="profileContentData pt-2">
          <FormEleWrapper className="pt-0">
            <ValidatedInput
              weight="600"
              name="name"
              type="input"
              fieldType="text"
              placeholder="first_name"
              label="first_name"
              className="combined px-0"
              // staric="staric"
              register={register}
              errors={errors}
              validationRules={{
                required: true,
              }}
            />

            <ValidatedInput
              weight="600"
              name="email"
              type="input"
              fieldType="text"
              placeholder={"email"}
              label="email"
              className="combined px-0"
              // staric="staric"
              errors={errors}
              register={register}
              validationRules={{
                required: true,
              }}
            />

            <PhoneInputField
              bg="transparent"
              weight="600"
              name="phone"
              label={"phone"}
              placeholder={"phone"}
              register={register}
              control={control}
              errors={errors}
              // staric={true}
              validationRules={{
                required: true,
              }}
              className={"mt-2 combined p-0"}
            />
          </FormEleWrapper>
          <Box className="commonBtns px-0">
            <ButtonStyled
              border="var(--borderExtraLight)"
              iconBefore={LeftArrowBlack}
              bg="transparent"
              label={t("Cancel")}
              color="var(--text)"
              type="button"
            />
            <ButtonStyled
              label={t("Update")}
              type="submit"
              isLoading={loading}
            ></ButtonStyled>
          </Box>
        </Box>
      </Form>
    </>
  );
};

export default AccountSetting;
